import React from "react";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Alert from '@mui/material/Alert';
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import { Trans } from "react-i18next";

import NavBar from "../components/NavBar";
import Footer from "../components/Footer";
import axios from "../components/Axios";
import "./Login.css";

class Index extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      errorMessage: "",
      successMessage: "",
      code: "",
      password: "",
    };
  }

  componentDidMount() {
    let queryParams = new URLSearchParams(window.location.search);
    this.setState({code: queryParams.get('c')})
  }

  handleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  submit(e) {
    e.preventDefault();
    this.setState({ loading: true, errorMessage: "" });
    axios
      .post("/setpw", {code: this.state.code, password: this.state.password})
      .then(
        function (response) {
          //this.setState({items: response.data});
          if ("error_code" in response.data) {
            this.setState({
              loading: false,
              errorMessage: response.data.message,
            });
          } else if ("message" in response.data) {
            this.setState({
              loading: false,
              successMessage: response.data.message,
            });
          }
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log(error);
          if (error.response.status === 400) {
            if('message' in error.response.data){
                this.setState({ errorMessage: error.response.data.message });
            }else{
                this.setState({ errorMessage: "Unknown Error" });
            }
          } else if (error.response.status === 401) {
            this.setState({ errorMessage: "Invalid email or password" });
          } else if (error.response.status === 500) {
            this.setState({ errorMessage: error.response.data.message });
          } else {
            this.setState({ errorMessage: "Unknown Error" });
          }
          this.setState({ loading: false });
        }.bind(this)
      );
    return false;
  }

  render() {
    return (
      <div
        className="background"
        style={{ display: "flex", flexDirection: "column" }}
      >
        <NavBar />
        <Container maxWidth="xs" style={{ marginTop: "64px", flex: "1" }}>
          <Typography variant="h5" gutterBottom className="loginTitle">
            <Trans>Set your Password</Trans>
          </Typography>

          <p className="loginText">
            <Trans>Enter your new password below</Trans>
          </p>
          <form onSubmit={this.submit.bind(this)}>
            <label
              htmlFor="password"
              style={{ color: "#063e6c", fontWeight: "bold" }}
            >
              <Trans>New Password</Trans>
            </label>
            <br />
            <TextField
              name="password"
              id="password"
              variant="outlined"
              size="small"
              value={this.state.password}
              onChange={this.handleChange.bind(this)}
              type="password"
              autoFocus
              required
              fullWidth
              style={{marginBottom: '8px'}}
            />
            {this.state.errorMessage !== "" && (
              <Alert
                severity="error"
                onClose={() => {
                  this.setState({ errorMessage: "" });
                }}
              >
                {this.state.errorMessage}
              </Alert>
            )}
            
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                margin: "32px 0",
              }}
              hidden={this.state.successMessage !== ""}
            >
              <div>

              </div>
              <Button
                className="Button ButtonPrimary"
                size="small"
                type="submit"
                disabled={this.state.loading}
              >
                <Trans>Set Password</Trans>
              </Button>
            </div>
            {this.state.successMessage !== "" && (
              <>
              <Alert
                severity="success"
                onClose={() => {
                  this.setState({ successMessage: "" });
                }}
              >
                Your password has been set. You can <Link to='/login'>login</Link> now.
              </Alert>
              <br/>
              </>
            )}
          </form>
        </Container>
        <Footer></Footer>
      </div>
    );
  }
}

export default withRouter(Index);
